exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".m-token-content[data-v-666469e6]{display:flex;flex-direction:column;align-items:center;padding:5px 20px 0}.m-token-content .binding[data-v-666469e6]{width:100%;color:#666;line-height:1.6;text-align:center}.m-token-content .qr-code[data-v-666469e6]{display:flex;justify-content:center;min-height:220px;margin:12px 0}.m-token-content .secret[data-v-666469e6]{color:#999;font-size:12px;word-break:break-all}.m-token-content .error[data-v-666469e6]{width:100%;margin:10px 0 0;color:#f56c6c;font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-666469e6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/mToken/mTokenDialog.vue
// module id = 551
// module chunks = 1